<template src="./component.html"></template>

<script>
import Client from './_client/component';
import Form from './_form/component';
import HowWork from './_howWork/component';
import Module from './_module/component';
import Advantages from './_advantages/component';
import Possibility from './_possibility/component';
import Scheme from './_scheme/component';
import Promo from './_promo/component';

export default {
  name: "MainPage",
  components: {
    Client,
    Form,
    HowWork,
    Module,
    Advantages,
    Possibility,
    Scheme,
    Promo
  },
}
</script>

<style src="./component.scss" scoped lang="scss"/>
